import { Link } from "react-router-dom";
import { Logo, ProductMark, IsoCred } from "@/components/Brand";
import { ShieldCheck, ArrowLeft } from "lucide-react";

export const PublicFooter = () => (
  <footer className="border-t bg-white" data-testid="public-footer">
    <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col md:flex-row gap-3 items-center justify-between text-xs text-[#5A6B87]">
      <div>© {new Date().getFullYear()} Nirogyam Diagnostics and Healthcare Pvt Ltd. <IsoCred /> is an accreditation-readiness tool, not an official NABL platform.</div>
      <div className="flex gap-4 items-center">
        <Link to="/legal/terms" className="hover:text-[#48217A]" data-testid="footer-terms-link">Terms</Link>
        <Link to="/legal/privacy" className="hover:text-[#48217A]" data-testid="footer-privacy-link">Privacy</Link>
        <Link to="/admin/login" className="inline-flex items-center gap-1 font-medium text-[#48217A] hover:underline" data-testid="footer-admin-login-link">
          <ShieldCheck className="h-3.5 w-3.5" /> Administrator Login
        </Link>
        <Link to="/qlog" className="inline-flex items-center gap-1 whitespace-nowrap text-[#5A6B87] hover:text-[#48217A]" data-testid="footer-dev-login-link">
          Q log
        </Link>
      </div>
    </div>
  </footer>
);

export const AuthLayout = ({ title, subtitle, children, side = true, onBack }) => (
  <div className="min-h-screen flex flex-col bg-[#F4F6F8]">
    <div className="flex-1 grid lg:grid-cols-[1.05fr_1fr]">
      {side && (
        <div className="hidden lg:flex relative overflow-hidden bg-[#48217A] text-white p-12 flex-col justify-between">
          <img src="/brand/hero-lab.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
          <div className="relative bg-white rounded-xl p-3 w-fit"><Logo className="h-10" /></div>
          <div className="relative max-w-md">
            <div className="text-[11px] tracking-[0.25em] uppercase text-[#9FE3BF] font-semibold mb-3"><IsoCred /> · ISO 15189:2022</div>
            <h2 className="font-display text-4xl font-extrabold leading-tight">Every Clause. Every Document. Every Step Towards Accreditation.</h2>
            <p className="mt-4 text-white/75 text-sm">Your laboratory's intelligent path to quality and compliance.</p>
          </div>
          <div className="relative text-xs text-white/60">Internal readiness indicators only — accreditation decisions rest with NABL.</div>
        </div>
      )}
      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="flex items-center justify-between gap-3 mb-8">
            <Link to="/" className="inline-block"><ProductMark /></Link>
            <Link to="/" onClick={onBack ? (e) => { e.preventDefault(); onBack(); } : undefined} className="inline-flex items-center gap-1 text-sm font-medium text-[#48217A] hover:underline shrink-0" data-testid="auth-back-home"><ArrowLeft className="h-4 w-4" />Back to home</Link>
          </div>
          <h1 className="font-display text-2xl font-bold text-[#172238]">{title}</h1>
          {subtitle && <p className="text-sm text-[#5A6B87] mt-1 mb-6">{subtitle}</p>}
          <div className="qt-card p-6 fade-up">{children}</div>
        </div>
      </div>
    </div>
    <PublicFooter />
  </div>
);
